import { APPROVAL_ROUTES } from '@/features/approval/navigation';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Pencil, Minus, Plus, Settings } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { SpinnerOverlay } from '@/components/ui/Spinner';
import ConfirmDeleteDialog from '@/components/ui/ConfirmDeleteDialog';
import moment from 'moment';
import Bar from '../../../components/elements/Bar';
import List from '../../../components/elements/List';
import BaseContainer from '../../../components/containers/BaseContainer';
import MainContainer from '../../../components/containers/MainContainer';
import EditCompanyModal from './components/modals/EditCompanyModal';
import {
  editCompany,
  updateMembers,
  loadCompanyDetail,
  updateStorage,
} from '@/store/actions/company';
import SharedModlalToAddItemFromList from '../../../components/modals/SharedModlalToAddItemFromList';
import { apiService } from '../../../utils/api';
import { isEmptyObject } from '../../../utils/object';

const getEmployees = async (nextProps, search) =>
  await apiService.get(`/api/v1/employee/left-panel`, {
    params: {
      page: nextProps,
      search: search,
      page_size: 20,
    },
  });

const detailData = (data) => {
  if (!data) return [];
  const { ico, dic, title, address, description } = data;
  return [
    { name: 'IČ', value: ico },
    { name: 'DIČ', value: dic },
    { name: 'Název', value: title },
    { name: 'Sídlo', value: address },
    { name: 'Zaměření', value: description },
  ];
};

const detailStorage = (data) => {
  if (!data || Object.keys(data).length === 0 || !data.storage_info) return [];
  const {
    storage_info: { capacity, status_data, type, used },
  } = data;
  return [
    { name: 'Název služby', value: type },
    { name: 'Stav', value: status_data },
    { name: 'Účet', value: used },
    { name: 'Dostupná kapacita', value: capacity },
  ];
};

const licenceData = (data) => {
  if (!data) return [];

  const { licence_status, licence, invoicing_email, licence_last_payday, licence_next_payday } =
    data;
  return [
    { name: 'Stav', value: licence_status },
    { name: 'Aktuální plán', value: licence.active_plan },
    { name: 'Faktury zasílat na', value: invoicing_email },
    {
      name: 'Datum poslední platby',
      value: moment(licence_last_payday || '').format('DD.MM.YYYY'),
    },
    {
      name: 'Datum příští platby',
      value: moment(licence_next_payday || '').format('DD.MM.YYYY'),
    },
  ];
};

const adminData = (data) => {
  if (!data) return [];
  const { administrators } = data;

  return (administrators || []).map((ele) => ({
    name: ele.user_name,
    value: ele.user_mail,
    id: ele?.id,
  }));
};

function Company() {
  const [visible, setVisible] = useState(false);
  const [addEmployeesVisible, setAddEmployeesVisible] = useState(false);
  const [error, setError] = useState(null);
  const [nextEmployees, setNextEmployees] = useState(null);
  const [searchInEmployees, setSearchInEmployees] = useState(null);
  const [_visibleStorage, setVisibleStorage] = useState(false);
  const [employees, setEmployees] = useState(null);

  // const { current_company: current } = useSelector((state) => state.auth);

  const permission = useSelector((state) => state.auth.pagePermission);
  const _company = useSelector((state) => state.company);

  const { detail: fetchedCompany } = _company;

  console.log({ fetchedCompany });

  const dispatch = useDispatch();
  const history = useHistory();

  const fetchDataEmployee = async () => {
    const { data: employees } = await getEmployees(1, null);
    setEmployees(employees?.results);
    setNextEmployees(employees?.next);
  };

  // useEffect(() => {
  //   if (current) {
  //     dispatch(loadCompanyDetail());
  //   }
  // }, []);

  useEffect(() => {
    dispatch(loadCompanyDetail());
    fetchDataEmployee();
  }, []);

  const makeModalVisible = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
    setVisibleStorage(false);
    setError(null);
  };

  const submitEditForm = async (values) => {
    const { status, error } = dispatch(editCompany(values)) as any;

    if (status === true) {
      setVisible(false);
      setError(null);
    }
    if (error) {
      setError(error);
    }
  };

  const deleteButton = (values) => (
    <ConfirmDeleteDialog
      title="Opravdu chcete odstranit zaměstnance?"
      onConfirm={() => dispatch(updateMembers(values, 'remove_from'))}
    >
      <Minus key={1} className="h-4 w-4" />
    </ConfirmDeleteDialog>
  );

  const addAdmin = (data) => {
    setAddEmployeesVisible(false);
    dispatch(updateMembers(data, 'add_to'));
  };

  const onSearchEmployees = async (e) => {
    setSearchInEmployees(e?.target?.value);
    try {
      const { data } = await getEmployees(1, e?.target?.value);
      if (data) {
        setEmployees(data?.results || []);
        setNextEmployees(data?.next);
      }
    } catch {
      //
    }
  };
  const fetchMoreEmployees = async () => {
    if (nextEmployees !== null) {
      try {
        const { data } = await getEmployees(nextEmployees, searchInEmployees);

        if (data) {
          setEmployees(employees.concat(data?.results || []));
          setNextEmployees(data?.next);
        }
      } catch {
        //   setError(e);
      }
    }
  };
  const _submitStorageForm = async (values) => {
    const { status, error } = dispatch(updateStorage(values)) as any;

    if (status) {
      setVisibleStorage(false);
      setError(null);
    }
    setError(error);
  };

  //! storage modal is now unused and is waiting for new API
  const _renderDataStorage = () => (
    <BaseContainer margin width={'100%' as any}>
      <Bar
        text="Datový sklad"
        content={
          permission === 2
            ? [
                <Pencil
                  key={1}
                  className="h-4 w-4"
                  data-testid="company-storage-edit-btn"
                  onClick={() => setVisibleStorage(true)}
                />,
              ]
            : []
        }
      />
      <List data={detailStorage(fetchedCompany)} />
    </BaseContainer>
  );

  const preparedAdminData = adminData(fetchedCompany);

  if (isEmptyObject(fetchedCompany)) {
    return (
      <MainContainer>
        <BaseContainer fullHeight margin width={'100%' as any}>
          <div className="size-full flex justify-center align-items-center">
            <SpinnerOverlay size="lg" />
          </div>
        </BaseContainer>
      </MainContainer>
    );
  }

  return (
    <>
      <MainContainer>
        <BaseContainer fullHeight margin width={'100%' as any}>
          <BaseContainer margin width={'100%' as any}>
            <Bar
              text="Detail firmy"
              content={
                permission === 2
                  ? [
                      <Pencil
                        key={1}
                        className="h-4 w-4"
                        data-testid="company-detail-edit-btn"
                        onClick={makeModalVisible}
                      />,
                    ]
                  : []
              }
            />
            <List data={detailData(fetchedCompany)} />
          </BaseContainer>
          <BaseContainer margin width={'100%' as any}>
            <Bar
              text="Předplatné a fakturace"
              content={
                permission === 2
                  ? [
                      <Pencil
                        key={1}
                        className="h-4 w-4"
                        data-testid="company-licence-edit-btn"
                        onClick={() => history.push('/app/nastaveni/sprava-firmy/faktury')}
                      />,
                    ]
                  : []
              }
            />
            <List data={licenceData(fetchedCompany)} />
          </BaseContainer>
          <BaseContainer margin width={'100%' as any}>
            <Bar
              text="Správci firmy"
              content={
                permission === 2
                  ? [
                      <Plus
                        key={1}
                        className="h-4 w-4"
                        data-testid="company-admin-add-btn"
                        onClick={() => setAddEmployeesVisible(true)}
                      />,
                    ]
                  : []
              }
            />
            <List
              data={preparedAdminData}
              actions={preparedAdminData.length > 1 ? [deleteButton] : []}
            />
          </BaseContainer>
          <BaseContainer margin width={'100%' as any}>
            <Bar
              text="Schvalování řešení"
              content={[
                <Settings
                  key={1}
                  className="h-4 w-4"
                  data-testid="company-approval-settings-btn"
                  onClick={() => history.push(APPROVAL_ROUTES.settings)}
                />,
              ]}
            />
            <List
              data={[
                {
                  name: 'Stav',
                  value: fetchedCompany?.solution_approval_required ? 'Zapnuto' : 'Vypnuto',
                },
              ]}
            />
          </BaseContainer>
          {/* {_renderDataStorage()} */}
          {/* <GoogleClient /> */}
        </BaseContainer>
      </MainContainer>
      <EditCompanyModal
        title="Editace firmy"
        data={fetchedCompany}
        visible={visible}
        submitEditForm={submitEditForm}
        error={error}
        onClose={onClose}
      />
      <SharedModlalToAddItemFromList
        data={employees}
        title="Přidat správce"
        visible={addEmployeesVisible}
        onSearch={onSearchEmployees}
        hasMore={nextEmployees !== null ? true : false}
        fetchMore={fetchMoreEmployees}
        onClose={() => setAddEmployeesVisible(false)}
        submit={addAdmin}
      />
    </>
  );
}

export default Company;
